import { forwardRef } from 'react';
import { Grid as MUIGrid } from '@mui/material';
import type { GridProps as MUIGridProps } from '@mui/material';

export type GridProps = MUIGridProps;

export const Grid = forwardRef<HTMLDivElement, MUIGridProps>(
  function Grid(props, ref) {
    return <MUIGrid ref={ref} {...props} />;
  },
);
